"use client";

import { Toaster as ChakraToaster, Portal, Toast, createToaster } from "@chakra-ui/react";

export const toaster = createToaster({
	placement: "top",
	pauseOnPageIdle: true,
});

export function Toaster() {
	return (
		<Portal>
			<ChakraToaster toaster={toaster} insetInline={{ mdDown: "4" }}>
				{(toast) => (
					<Toast.Root width={{ md: "sm" }}>
						<Toast.Indicator />
						<Toast.Title>{toast.title}</Toast.Title>
					</Toast.Root>
				)}
			</ChakraToaster>
		</Portal>
	);
}
